<app-notification></app-notification>
<div class="app-container">
  <div class="app-container-stretch-box">

    <app-header></app-header>

    <div fxLayout="column" fxLayoutAlign="space-between center" fxFlex="" class="app-container-content"
      [ngClass]="{'app-container-content-narrow-footer': isProduction && isListView, 'app-container-content-non-prod-narrow-footer': (!isProduction && isListView), 'app-container-content-non-prod': (!isProduction && !isListView)}">
      <div style="max-width: 1234px;">
        <router-outlet></router-outlet>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</div>
